module.exports = "label {\n    padding: 8px;\n    color: darkslategray;\n}\n\n.padding_10 {\n    padding: 10px;\n}\n\n.table_padding {\n    padding: 4px;\n}\n\n.fix-height {\n    padding: 2px;\n}\n\n.f-s-16 {\n    font-size: 16px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/scrap/scrap.component.css
// module id = ./src/app/scrap/scrap.component.css
// module chunks = main